import { Component, inject } from '@angular/core';
import { DevManagementDataService } from '@app/admin/services/devmanagement.service';
import { RoleRightPatchModel } from '@app/admin/shared/RoleRightMaintenanceModel';
import { GenericListConfig } from '@app/shared/models/GenericList/GenericList';
import { GenericListFieldType } from '@app/shared/models/GenericList/GenericListField';
import { SharedModule } from '@app/shared/shared.module';
import { injectTranslation } from '@app/shared/i18n/translation-scope';
import { scope } from '@app/admin/i18n/scope';

@Component({
    selector: 'dev-role-right-patches',
    templateUrl: './dev-role-right-patches.component.html',
    styleUrls: ['./dev-role-right-patches.component.scss'],
    imports: [SharedModule]
})
export class DevRoleRightPatchesComponent {
    private _ds = inject(DevManagementDataService);
    private translation = injectTranslation(scope);

    config: GenericListConfig;

    constructor() {
        this.loadPatches();
    }

    async loadPatches() {
        await this.translation.ready();
        this._ds.getRoleRightPatches().subscribe(x => this.setupConfig(x));
    }

    setupConfig(patches: RoleRightPatchModel[]) {
        this.config = <GenericListConfig>{
            name: this.translation.t("devRoleRightPatches.listName"),
            data: patches,
            idProp: 'guid',

            allowAdd: false,
            allowEdit: false,
            allowDelete: true,

            fields: [{
                fieldName: "roleName",
                prettyName: this.translation.t("devRoleRightPatches.roleField"),
                fieldType: GenericListFieldType.Text,
            }, {
                fieldName: "rightName",
                prettyName: this.translation.t("devRoleRightPatches.rightField"),
                fieldType: GenericListFieldType.Text,
            }, {
                fieldName: "defaultValue",
                prettyName: this.translation.t("devRoleRightPatches.linkedByDefaultField"),
                fieldType: GenericListFieldType.CheckBox,
            }, {
                fieldName: "currentValue",
                prettyName: this.translation.t("devRoleRightPatches.currentlyLinkedField"),
                fieldType: GenericListFieldType.CheckBox,
            }],

            deleteOverride: (row: RoleRightPatchModel) => {
                this._ds.deleteRoleRightDefinition(row.roleID, row.rightID).subscribe(() => {
                    this._ds.getRoleRightPatches().subscribe(x => {
                        this.config.data = x;
                        this.config.reload();
                    });
                });
            }
        };
    }
}
